import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-withdraw-tooltip',
  templateUrl: './withdraw-tooltip.component.html',
  styleUrls: ['./withdraw-tooltip.component.scss'],
})
export class WithdrawTooltipComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
